/* unplugin-vue-components disabled */import { render } from "./imagetrans_head.vue?vue&type=template&id=b8712c8c&scoped=true"
import script from "./imagetrans_head.vue?vue&type=script&lang=js"
export * from "./imagetrans_head.vue?vue&type=script&lang=js"

import "./imagetrans_head.vue?vue&type=style&index=0&id=b8712c8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8712c8c"]])

export default __exports__